module.exports = __webpack_public_path__ + "static/media/Association of Rehabilitation Nurses Logo.504dafad.jpg";